import { Button } from 'blaze-ui/Button'
import { AlertTriangle } from 'blaze-ui/icons/20/AlertTriangle'
import cx from 'classnames'
import Styles from './ValidationBanner.module.scss'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { getCharacterLimitViolations, type PlatformLimits } from './utils'
import { getPlatformDisplayName } from 'utils/platformDisplayNames'

interface ValidationBannerProps {
  content: string
  selectedPlatform?: PlatformLimits
  className?: string
  hideIcon?: boolean
  action?: {
    label: string
    onClick: () => void
  }
}

export const ValidationBanner = ({
  content,
  selectedPlatform,
  className,
  hideIcon = false,
  action,
}: ValidationBannerProps) => {
  const violations = selectedPlatform ? getCharacterLimitViolations(content, [selectedPlatform]) : []

  if (violations.length === 0) {
    return null
  }

  const getMessage = () => {
    const violation = violations[0]
    const platformDisplayName = getPlatformDisplayName(violation.platform as ExternalIntegrationEnum)
    return `Your post exceeded the character limit for ${platformDisplayName}`
  }

  return (
    <div className={cx(Styles.banner, className)} data-testid="validation-banner">
      {!hideIcon && (
        <div className={Styles.iconSection} data-testid="validation-icon">
          <AlertTriangle size={20} color="var(--negative-60)" />
        </div>
      )}
      <div className={Styles.content}>
        <span className={Styles.message}>{getMessage()}</span>
      </div>
      {action && (
        <Button
          variant="tertiary"
          size="sm"
          onPress={action.onClick}
          className={Styles.actionButton}
          data-testid="validation-action-button"
        >
          {action.label}
        </Button>
      )}
    </div>
  )
}
